import { useEffect, useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language || 'az');

  // Sync <html lang> on mount so screen readers use the right pronunciation.
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = i18n.language || 'az';
    }
  }, [i18n.language]);

  const handleChange = (_: any, newLang: string | null) => {
    if (newLang) {
      setLang(newLang);
      i18n.changeLanguage(newLang);
      localStorage.setItem('cm_lang', newLang);
      // Set lang synchronously too — avoids a race where consumers read
      // the attribute before React re-renders.
      if (typeof document !== 'undefined') {
        document.documentElement.lang = newLang;
      }
    }
  };

  return (
    <ToggleButtonGroup value={lang} exclusive onChange={handleChange} size="small"
      aria-label="Language selector"
      sx={{ '& .MuiToggleButton-root': { px: 2, py: 0.5, fontSize: '0.8rem', textTransform: 'none', fontWeight: 600 } }}>
      <ToggleButton value="az" aria-label="Azerbaijani">AZ</ToggleButton>
      <ToggleButton value="ru" aria-label="Russian">RU</ToggleButton>
      <ToggleButton value="en" aria-label="English">EN</ToggleButton>
    </ToggleButtonGroup>
  );
}
